import { request } from '../index'

export function stockProducts(params = {}) {
    return request({ url: "products/stocks/", params })
}
export function getStockInfo() {
    return request({ url: "products/stock-info/" })
}
export function getStockInfoHistory(params) {
    return request({ url: "products/stock-history/", params })
}
export function updateProductStock(data) {
    return request({ url: "products/stocks/", data, method: "POST" })
}


// WEBPACK FOOTER //
// ./src/api/stocks/index.js